import { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { useRoutes } from '../../hooks/useRoutes';
import useThrowAsyncError from '../../hooks/useThrowAsyncError';
import { getQrCodeInfoById, QrCodeInfo } from './api';

export default function LaunchQRCode() {
  const { id } = useParams<{ id: string }>();
  const { buildAbsolutePath } = useRoutes();
  const handleError = useThrowAsyncError();

  const [qrCodeInfo, setQrCodeInfo] = useState<QrCodeInfo>();

  useEffect(() => {
    async function fetchQrCode() {
      try {
        const qrCodeInfo = await getQrCodeInfoById(id!);
        setQrCodeInfo(qrCodeInfo);
      } catch (error) {
        handleError(error);
      }
    }

    fetchQrCode();
  }, [handleError, id]);
  if (qrCodeInfo === undefined) return null;

  const path = buildAbsolutePath(['LINKED_MATERIAL_LINK']);
  const query = new URLSearchParams();

  const { medialinkIds, slideSetIds } = qrCodeInfo.materials.reduce(
    (acc, cur) => {
      if (cur.medialinkId) {
        acc.medialinkIds.push(cur.medialinkId);
      }
      if (cur.slideSetId) {
        acc.slideSetIds.push(cur.slideSetId);
      }
      return acc;
    },
    {
      medialinkIds: [] as string[],
      slideSetIds: [] as number[],
    },
  );

  query.set('moduleId', qrCodeInfo.moduleId);
  if (medialinkIds.length > 0) query.set('medialinkIds', medialinkIds.join(','));
  if (slideSetIds.length > 0) query.set('slideSetIds', slideSetIds.join(','));

  return <Navigate to={`${path}?${query.toString()}`} replace />;
}
